export default __webpack_public_path__ + "static/media/Dvpt_facile.e2aa04d3.png";